module.exports = __webpack_public_path__ + "img/herby-1(768).0e68b02e.png";